// extracted by mini-css-extract-plugin
module.exports = {"has-subline":"Headline_has-subline__UMwnS","title":"Headline_title__QhO06"};